import { DatePicker, Select } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link } from "react-router-dom";
import { get_auditory } from "../../../../api/endpoints/auditory";
import { get_clients_simplified_checkpos } from "../../../../api/endpoints/clients";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import Main from "../../../layout/main/Main";
import { Typo } from "../../../layout/theme";
import {
	AntdButton,
	AuditCard,
	Container,
	ContentCard,
	FieldGroup,
	FieldLabel,
	FilterContainer,
	FilterGrid,
	ImageSection,
	Inner,
	PageTitle,
	PageWrapper,
	SectionTitle,
} from "./styles";

const { Option } = Select;

export default function Auditory() {
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [clients, setClients] = useState(null);
	const [selectedQuarter, setSelectedQuarter] = useState(null);
	const [isLoadingMonthly, setIsLoadingMonthly] = useState(false);
	const [isLoadingAnnual, setIsLoadingAnnual] = useState(false);

	const fetch_clients = async () => {
		const res = await get_clients_simplified_checkpos();
		setClients(res);
	};

	useEffect(() => {
		fetch_clients();
	}, []);

	const handleSubmit = async () => {
		if (!selectedMonth) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un mes",
				"Elija un mes para poder descargar.",
			);
			return;
		}

		setIsLoading(true);
		try {
			const data = {
				month: moment(selectedMonth).month() + 1,
				year: moment(selectedMonth).year(),
				quarter: 0,
				client: selectedClient || "",
			};
			const res = await get_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
			);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Month_" +
				(data.month + 1) +
				"_Quarter_" +
				data.year +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	const handleDownloadYear = async () => {
		if (!selectedQuarter) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un año",
				"Elija un año para poder descargar la auditoría anual.",
			);
			return;
		}

		setIsLoading(true);
		try {
			const data = {
				month: 0,
				year: moment(selectedQuarter).year(),
				quarter: moment(selectedQuarter).quarter(),
				client: selectedClient || "",
			};
			const res = await get_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
			);
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Year_" +
				data.year +
				"_Quarter_" +
				data.quarter +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Auditoria</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>
			<Main.Body>
				<PageWrapper>
					<ContentCard>
						<PageTitle>Gestión de Auditorías</PageTitle>
						<Inner>
							<AuditCard>
								<SectionTitle>Auditoría Mensual</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Elegir Cliente</FieldLabel>
										<FilterContainer>
											<Select
												value={selectedClient}
												onChange={(value) => setSelectedClient(value)}
												placeholder="Selecciona un cliente"
												showSearch
												optionFilterProp="children"
											>
												{clients?.map((client) => (
													<Option key={client.id} value={client.id}>
														{client.name}
													</Option>
												))}
											</Select>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<FieldLabel>Seleccionar Mes</FieldLabel>
										<FilterContainer>
											<DatePicker.MonthPicker
												value={selectedMonth}
												onChange={(e) => setSelectedMonth(e)}
												placeholder="Seleccionar mes"
												format="MMMM YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
								</FilterGrid>
								<AntdButton onClick={handleSubmit} loading={isLoading}>
									<BsDownload />
									Descargar Auditoría Mensual
								</AntdButton>
							</AuditCard>

							<AuditCard>
								<SectionTitle>Auditoría Trimestral</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Elegir Cliente</FieldLabel>
										<FilterContainer>
											<Select
												value={selectedClient}
												onChange={(value) => setSelectedClient(value)}
												placeholder="Selecciona un cliente"
												showSearch
												optionFilterProp="children"
											>
												{clients?.map((client) => (
													<Option key={client.id} value={client.id}>
														{client.name}
													</Option>
												))}
											</Select>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<FieldLabel>Seleccionar Trimestre</FieldLabel>
										<FilterContainer>
											<DatePicker.QuarterPicker
												value={selectedQuarter}
												onChange={(e) => setSelectedQuarter(e)}
												placeholder="Seleccionar trimestre"
												picker="quarter"
												format="[Q]Q YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
								</FilterGrid>
								<AntdButton onClick={handleDownloadYear} loading={isLoading}>
									<BsDownload />
									Descargar Auditoría Trimestral
								</AntdButton>
							</AuditCard>
						</Inner>
					</ContentCard>
				</PageWrapper>
			</Main.Body>
		</Main>
	);
}
